import React, { useEffect } from 'react'
import MobilePicker from 'react-mobile-picker'
import styles from './index.module.scss'
import './reset.scss'
import scrollLock from '../../utils/scroll-lock'
import './_variables.css'

const RcPicker = MobilePicker as any

interface IProps {
  title?: string
  confirmTxt?: string
  onCancel: () => void
  onConfirm: (result: object) => void
  onChange?: (name, value) => void
  optionGroups: Record<string, string[]> | undefined
  valueGroups: Record<string, string> | undefined
  itemHeight?: number
  height?: number
}

export default function Picker(props: IProps) {
  useEffect(() => {
    scrollLock.enable()

    return () => {
      scrollLock.disable()
    }
  }, [])

  const handleChange = (name, value) => {
    props.onChange && props.onChange(name, value)
  }

  return (
    <div className={styles.pickerModalWrapper}>
      <div
        className={styles.pickerModalMask}
        onClick={() => props.onCancel()}
      ></div>
      <div className={`${styles.pickerModal} ${styles.pickerModalToggle}`}>
        <div className={styles.closeIcon} onClick={props.onCancel}></div>
        <div className={styles.title}>{props.title || '请选择'}</div>
        <RcPicker
          optionGroups={props.optionGroups}
          valueGroups={props.valueGroups}
          onChange={handleChange}
          itemHeight={props.itemHeight}
          height={props.height}
        />
        <div className={styles.okBtnCon}>
          <div className={styles.okBtn} onClick={props.onConfirm}>{props.confirmTxt || '确认'}</div>
        </div>
      </div>
    </div>
  )
}
